import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const AlertError18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_491)'>
      <path
        d='M10.0606 8.99994L12.3033 11.2426L11.2426 12.3033L8.99995 10.0606L6.75725 12.3033L5.69659 11.2426L7.93929 8.99994L5.93934 6.99999L7 5.93933L8.99995 7.93928L10.9999 5.93934L12.0605 7L10.0606 8.99994Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M0.25 9C0.25 4.16751 4.16751 0.25 9 0.25C13.8325 0.25 17.75 4.16751 17.75 9C17.75 13.8325 13.8325 17.75 9 17.75C4.16751 17.75 0.25 13.8325 0.25 9ZM9 1.75C4.99594 1.75 1.75 4.99594 1.75 9C1.75 13.0041 4.99594 16.25 9 16.25C13.0041 16.25 16.25 13.0041 16.25 9C16.25 4.99594 13.0041 1.75 9 1.75Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_491'>
        <rect width='18' height='18' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

AlertError18.displayName = 'AlertError18';
export default AlertError18;
